import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, TextField, Grid,CardHeader } from '@material-ui/core';
import { colors } from '@material-ui/core';


class SearchToolbar extends Component {
    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.keyPress = this.keyPress.bind(this);
        this.onSubmitByCoverage = this.onSubmitByCoverage.bind(this);
        this.state = {
            searchKeyword: '',
            coverage:'per_trip'
        }
    }
      
    onSubmit( isReset ) {
        if( isReset){
            this.state.searchKeyword = '';
        }
        this.props.onSubmit( this.state.searchKeyword, this.state.coverage );
    }
    
    keyPress(e){
      if(e.keyCode === 13){
         this.onSubmit( false );
      }
   }

   onSubmitByCoverage( coverage ) {
       this.setState({
           coverage: coverage
       });
       this.props.onSubmit( '', coverage );
   }
   
    render() {
    return (
        <div >
            <CardHeader title="Contents" subheader={'Contents > List/Search ' + this.props.subTitle}/>
            <Grid container spacing={2} >
            <Grid item md={12} xs={12} >
            { (this.props.subTitle!=='Flight Status Disclaimer' && this.props.subTitle!=='Travel Advisory') &&(
            <div style={{padding:10, background:colors.back}}>
                <Button color={this.state.coverage==='per_trip'?'primary':'other'} variant="contained" style={{textTransform: 'capitalize', minWidth:'50%'}}
                        onClick={event => this.onSubmitByCoverage('per_trip')}>Per Trip</Button>
                <Button color={this.state.coverage==='annual'?'primary':'other'} variant="contained" style={{marginLeft:0, textTransform: 'capitalize', minWidth:'50%'}}
                        onClick={event => this.onSubmitByCoverage('annual')}>Annual</Button>
            </div>
            )}
            </Grid>
            <Grid item md={6} xs={12} >
                <TextField fullWidth label="Search" name="title" margin="dense" variant="outlined" size="small"
                    value={this.state.searchKeyword}
                    onKeyDown={this.keyPress}
                    color="primary"
                    onChange={ ( event ) => { this.setState( {searchKeyword: event.target.value }) } }
                />
            </Grid>
            <Grid item md={6} xs={12} >
                <Button color="primary" variant="contained" style={{textTransform: 'capitalize'}}
                        onClick={event => this.onSubmit(false)}>Search</Button>
                <Button color="other" variant="contained" style={{marginLeft:20, textTransform: 'capitalize'}}
                        onClick={event => this.onSubmit(true)}>Reset</Button>
            </Grid>
            </Grid> 
        </div>
    );
    }
}
SearchToolbar.propTypes = {
  className: PropTypes.string,
  subTitle: PropTypes.string,
  onSubmit: PropTypes.func.isRequired
};

export default SearchToolbar;
